module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-6b140f752b3a4929740fd8dc5609171c.svg";